
import { defineComponent, onMounted } from 'vue';
import { AppTable, AppCard, AppButton } from '@/components';
import { usePicwordMapList } from '@/modules/picword/map/model/list';
import { ROUTE_NAME_PICWORD } from '@/modules/picword/router';
import { TableColumnType, TableConfig } from '@/components/table/types';

export default defineComponent({
    name: ROUTE_NAME_PICWORD.MAP.INDEX,
    components: { AppTable, AppCard, AppButton },
    setup() {
        const { list, total, query, fetchList, actions } = usePicwordMapList();

        const table: TableConfig = {
            columns: [
                { type: TableColumnType.Text, label: 'ID', key: 'id' },
                { type: TableColumnType.Text, label: 'Name', key: 'name' },
                { type: TableColumnType.Text, label: 'Price', key: 'price' },
                { type: TableColumnType.Actions, label: 'Actions' }
            ],
            actions: [
                {
                    props: (row: any) => ({
                        icon: 'fa-edit',
                        theme: 'info',
                        tooltip: 'Edit',
                        to: { name: ROUTE_NAME_PICWORD.MAP.EDIT, params: { id: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-eye',
                        theme: 'info',
                        tooltip: 'Detail',
                        to: { name: ROUTE_NAME_PICWORD.MAP.DETAIL, params: { id: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-trash-alt',
                        theme: 'danger',
                        tooltip: 'Delete',
                        disabled: !row.canDelete,
                        onClick: () => actions.remove(row.id)
                    })
                }
            ]
        };

        onMounted(fetchList);

        return { table, list, total, query, fetchList, ROUTE_NAME_PICWORD };
    }
});
